import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import TermsConditions from './modals/terms_conditions';
import { checkLogin, loggout } from '../utils/functions';
import { saveUser } from '../redux/reducers/userSlice';

export default function TermsGate() {
  const user = useSelector(state => state.user?.data);
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const suppressRef = useRef(false);

  useEffect(() => {
    if (!checkLogin()) { setOpen(false); return; }
    if (!user || !user._id) { setOpen(false); return; }

    if (user?.conditionAccepted === true) {
      suppressRef.current = false; // reset suppression when accepted
      setOpen(false);
      return;
    }

    if (!suppressRef.current) {
      setOpen(true);
    }
  }, [user]);

  // Called from Accept / Decline buttons inside TermsConditions (via onClose)
  const handleClose = (accepted) => {
    if (accepted) {
      // Accepted
      suppressRef.current = true;
      setOpen(false);
      if (user) dispatch(saveUser({ ...user, conditionAccepted: true }));
      enqueueSnackbar('User agreement accepted', { variant: 'success' });
    } else {
      // Decline: just show warning and keep modal open
      enqueueSnackbar('You cannot proceed without accepting buyer agreement.', { variant: 'error' });
      suppressRef.current = false;
      setOpen(true);
    }
  };

  if (!open) return null;
  return (
    <TermsConditions
      open={open}
      handleClose={handleClose}
      // This is called ONLY when user clicks close (X) or backdrop on the modal
      setIsModalOpen={(isOpen) => {
        if (!isOpen) {
          // Treat as hard close: logout + redirect to login/landing
          suppressRef.current = true;
          setOpen(false);
          loggout();
          navigate('/', { replace: true });
        } else {
          setOpen(true);
        }
      }}
    />
  );
}


